import styles from './Table.css'
import {clickOutletRow} from 'actions/outletPages/list'
import {askConfirmAction} from 'actions/confirm-action'
import { connect } from 'react-redux'

class Table extends React.Component {
  render () {
    const {outlets} = this.props

    return (outlets.length > 0 &&
      <div className={styles.wrapper}>
        <table className={`table ${styles['table-header']}`}>
          <thead>
            <tr>
              <th className={styles.name}>Outlet Name</th>
              <th className={styles.address}>Address</th>
              <th className={styles.phone}>Phone</th>
              <th className={styles.city}>City</th>
              <th className={styles.province}>Province</th>
              <th className={styles.status}>Status</th>
            </tr>
          </thead>
        </table>
        <div className={`${styles.scroll} outlet-scroll`}>
          <table className={`table ${styles['table-body']}`}>
            <tbody className={styles.tbody}>
              {outlets.map(this._renderRow)}
            </tbody>
          </table>
        </div>
      </div>)
  }

  _renderRow = (outlet) => {
    return (<tr onClick={() => this._onClickOutlet(outlet)} className={this._isSelected(outlet) ? styles.selected : ''}>
      <td className={styles.name}>{outlet.name}</td>
      <td className={styles.address}>{outlet.address}</td>
      <td className={styles.phone}>{outlet.phone_number}</td>
      <td className={styles.city}>{outlet.city}</td>
      <td className={styles.province}>{outlet.province}</td>
      <td className={styles.status}>{this._renderOutletStatus(outlet)}</td>
    </tr>)
  }

  _renderOutletStatus = (outlet) => {
    if (!outlet.is_deleted) {
      return <span className={styles['outlet-active']}>Active</span>
    } else {
      return <span className={styles['outlet-inactive']}>Expired</span>
    }
  };

  _onClickOutlet = (outlet) => {
    const {isDirtyForm, dispatch} = this.props
    if (isDirtyForm) {
      dispatch(askConfirmAction(clickOutletRow(outlet.id)))
    } else {
      dispatch(clickOutletRow(outlet.id))
    }
  }

  _isSelected = (outlet) => {
    const {outletDetail} = this.props
    return (outletDetail && outlet.id === outletDetail.id)
  }
}

Table.propTypes = {
  outlets: React.PropTypes.array,
  dispatch: React.PropTypes.func,
  outletDetail: React.PropTypes.object,
  isDirtyForm: React.PropTypes.bool
}

function mapStateToProps (state) {
  let {showLoadingSpinnerPage} = state.loadingSpinner
  return {showLoadingSpinnerPage}
}

export default connect(mapStateToProps)(Table)



// WEBPACK FOOTER //
// ./app/pages/Outlets/List/Table/Table.js